export default (that) => [
  {
    text: that.$l('INDEX.btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    show: ({ materialAbnormalStatus }) => materialAbnormalStatus === 'N' || materialAbnormalStatus === 'R',
  },
  {
    text: that.$l('btn_tips_del') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    show: ({ materialAbnormalStatus }) => materialAbnormalStatus === 'N' || materialAbnormalStatus === 'R',
  },
  {
    text: that.$l('btn_tips_copy') || '复制单据',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    divided: false,
    allow: 'E',
    data: {},
  },
  {
    text: that.$l('INDEX.btn_tips_submit_review') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'approval',
    divided: true,
    allow: 'T',
    data: {},
    show: ({ materialAbnormalStatus }) => materialAbnormalStatus === 'N' || materialAbnormalStatus === 'R',
  },
  {
    text: that.$l('btn_tips_confirm_processing') || '确认处理',
    icon: 'el-icon-s-check',
    menuType: 'confirmProcess',
    divided: true,
    allow: 'C',
    data: {},
    show: ({ materialAbnormalStatus, processingStatus }) => materialAbnormalStatus === 'Y' && processingStatus != 'Y',
  }
]
